import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from "react-router-dom";
import './i18n/index';
import "./App.css";
import Layout from "./components/Layout";
import SyllabusAnalysis from './components/SyllabusAnalysis';
import OpticalReader from './components/OpticalReader';
import Home from './components/Home';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import QuestionOperations from './components/QuestionOperations';
import EBS from './components/EBS';
import CourseContents from './components/CourseContents';
import CourseDetails from './components/CourseDetails';
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API_BASE_URL from './config/api';
import AdminPanel from './components/AdminPanel';
import Requests from './components/Requests';
import PreviousExamResults from './components/PreviousExamResults';
import DekanExamResults from './components/DekanExamResults';
import ProgramBaskaniExamResults from './components/ProgramBaskaniExamResults';
import RektorExamResults from './components/RektorExamResults';
import Pretest from './components/Pretest';
import PreMidtermAnalysis from './components/PreMidtermAnalysis';
import KisiselPlanlama from './components/KisiselPlanlama';
import TopluAnaliz from './components/TopluAnaliz';
import PersonalAnalysis from './components/PersonalAnalysis';
import MaintenancePage from './components/MaintenancePage';

function App() {
  if (process.env.REACT_APP_MAINTENANCE_MODE === 'true') {
    return <MaintenancePage />;
  }

  const RequireAdmin = () => {
    const role = typeof window !== 'undefined' ? sessionStorage.getItem('userRole') : null;
    if (role === 'admin') {
      return <AdminPanel />;
    }
    return <Navigate to="/dashboard" replace />;
  };
  const RequireAuth = () => {
    const role = typeof window !== 'undefined' ? sessionStorage.getItem('userRole') : null;
    if (!role) {
      return <Navigate to="/" replace />;
    }
    return <Outlet />;
  };
  return (
    <div className="app-container">
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/admin" element={<RequireAdmin />} />
          <Route path="/*" element={
            <>
              <Header />
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<Home />} />
                  <Route element={<RequireAuth />}>
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="ebs" element={<EBS />} />
                    <Route path="questions" element={<QuestionOperations />} />
                    <Route path="pretest" element={<Pretest />} />
                    <Route path="pre-midterm-analysis" element={<PreMidtermAnalysis />} />
                    <Route path="kisisel-planlama" element={<KisiselPlanlama />} />
                    <Route path="toplu-analiz" element={<TopluAnaliz />} />
                    <Route path="personal-analysis" element={<PersonalAnalysis />} />
                    <Route path="syllabus-analysis" element={<SyllabusAnalysis />} />
                    <Route path="optical-reader" element={<OpticalReader />} />
                    <Route path="course-contents" element={<CourseContents />} />
                    <Route path="requests" element={<Requests />} />
                    <Route 
                      path="course/:programId/:courseCode" 
                      element={
                        <CourseDetails userType={typeof window !== 'undefined' ? sessionStorage.getItem('userRole') : null} />
                      } 
                      />
                      <Route path="course/:id" element={<CourseIdRedirect />} />
                      <Route path="home" element={<Navigate to="/dashboard" replace />} />
                      <Route path="exam-results" element={<PreviousExamResults />} />
                      <Route path="dekan-exam-results" element={<DekanExamResults />} />
                      <Route path="program-baskani-exam-results" element={<ProgramBaskaniExamResults />} />
                      <Route path="rektor-exam-results" element={<RektorExamResults />} />
                    </Route>
                </Route>
              </Routes>
            </>
          } />
        </Routes>
      </Router>
    </div>
  );
}

function CourseIdRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const go = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/course/${id}`);
        if (!res.ok) { navigate('/course-contents', { replace: true }); return; }
        const data = await res.json();
        const programId = data.programId || data.program_id;
        const courseCode = data.code || data.course_code;
        if (programId && courseCode) {
          navigate(`/course/${programId}/${courseCode}`, { replace: true });
        } else {
          navigate('/course-contents', { replace: true });
        }
      } catch {
        navigate('/course-contents', { replace: true });
      }
    };
    go();
  }, [id, navigate]);
  return null;
}

export default App;
